import VueResource from 'vue-resource'

/**
 * @param resposta O objeto de resposta de uma requisição assícrona feita com o VueResource
 * @param padroes Um objeto que define as mensagens de sucesso e erro para caso o back não envie nenhuma
 * @returns A mensagem do back, se não a mensagem definida em padroes, se não uma mensagem genérica
 */
export function pegarMensagemDeResposta (resposta: VueResource.HttpResponse, padroes?: Record<string, string>): string {
  function pegarMensagemDeRespostaDoBack (): string | null | undefined {
    if (resposta.ok) {
      return resposta.data.success
    }
    return resposta.data.error
  }

  function pegarMensagemDeRespostaPadrao (): string | null | undefined {
    if (!padroes) return null
    if (resposta.ok) {
      return padroes.success
    }
    return padroes.error
  }

  function pegarMensagemDeRespostaGenerica (): string {
    if (resposta.ok) {
      return 'O processo ocorreu com sucesso'
    }
    return 'Ocorreu um problema no processamento de sua requisição'
  }

  return pegarMensagemDeRespostaDoBack() || pegarMensagemDeRespostaPadrao() || pegarMensagemDeRespostaGenerica()
}

/**
 * Exibe no modal apropriado a mensagem resultante de uma requisição
 * @param resposta O objeto de resposta de uma requisição assícrona feita com o VueResource
 * @param modais Um objeto mapeando quais modais serão utilizados
 */
export function mostrarModalDeResposta (
  resposta: VueResource.HttpResponse,
  modais: Record<string, (text: string) => void>
): void {
  function selecionarModalConformeResposta () {
    if (resposta.ok) {
      return modais.modalDeSucesso
    }
    return modais.modalDeErro
  }
  const modal = selecionarModalConformeResposta()
  const textoDoModal = pegarMensagemDeResposta(resposta)
  modal(textoDoModal)
}
